import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import employee from '../class/employee';
import warehouse from '../class/warehouse';
import "../styles/ProductDetailPage.css";

const ProductDetailPage = () => {
    const [versamenti, setVersamenti] = useState([]);
    const [discharges, setDischarges] = useState([]);
    const [loading, setLoading] = useState(true);
    const { order_uuid } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        let user_obj = new employee();
        user_obj.isLogged().then(() => {
            fetchData();
        }).catch(() => {
            navigate('/login');
        });
    }, []);

    const fetchData = async () => {
        const warehouseData = new warehouse();

        try {
            const versamentiCallData = await warehouseData.getDetailVersamenti({ order_uuid });
            const versamentiArray = versamentiCallData?.movements || versamentiCallData?.versamenti || (Array.isArray(versamentiCallData) ? versamentiCallData : []);
            setVersamenti(versamentiArray);
        } catch (error) {
            console.error("Error fetching versamenti", error);
        }

        try {
            const dischargeCallData = await warehouseData.getDischargeHistory({ order_uuid });
            const dischargeArray = dischargeCallData?.history || dischargeCallData?.discharges || (Array.isArray(dischargeCallData) ? dischargeCallData : []);
            setDischarges(dischargeArray);
        } catch (error) {
            console.error("Error fetching discharge history", error);
        }

        setLoading(false);
    };

    const formatDateTime = (timestamp) => {
        return new Date(Number(timestamp) * 1000).toLocaleString('it-IT', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    const formatNumber = (value) => {
        if (value == null || isNaN(value)) return "0,00000";
        return Number(value).toLocaleString('it-IT', {
            minimumFractionDigits: 5,
            maximumFractionDigits: 5,
        });
    };

    if (loading) {
        return <div className="detail-page"><h2 className="page-title">Caricamento...</h2></div>;
    }

    return (
        <div className="detail-page">
            <div className="detail-header">
                <button onClick={() => navigate('/products')} className="btn-indietro">← Indietro</button>
                <h2 className="page-title">Dettaglio Ordine</h2>
            </div>

            <div className="detail-section">
                <h3 className="section-title">Versamenti (Avanzamenti Produzione)</h3>
                {versamenti.length === 0 ? (
                    <p className="no-data">Nessun versamento trovato</p>
                ) : (
                    <table>
                        <thead>
                            <tr className='table-head' style={{ backgroundColor: '#003049', color: '#fff', fontWeight: 'bold' }}>
                                <th>ID</th>
                                <th>Quantità</th>
                                <th>Data/Ora</th>
                                <th>Dipendente</th>
                            </tr>
                        </thead>
                        <tbody>
                            {versamenti.map(v => (
                                <tr key={v.id}>
                                    <td>{v.id}</td>
                                    <td>{formatNumber(v.quantity)}</td>
                                    <td>{formatDateTime(v.processed_datetime)}</td>
                                    <td>{v.employee_name} {v.employee_surname}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            <div className="detail-section">
                <h3 className="section-title">Storico Scarichi</h3>
                {discharges.length === 0 ? (
                    <p className="no-data">Nessuno scarico trovato</p>
                ) : (
                    <table>
                        <thead>
                            <tr className='table-head' style={{ backgroundColor: '#003049', color: '#fff', fontWeight: 'bold' }}>
                                <th>ID</th>
                                <th>Quantità</th>
                                <th>Data</th>
                                <th>N. DDT</th>
                                <th>Dipendente</th>
                            </tr>
                        </thead>
                        <tbody>
                            {discharges.map(d => (
                                <tr key={d.id}>
                                    <td>{d.id}</td>
                                    <td>{formatNumber(d.quantity)}</td>
                                    <td>{formatDateTime(d.discharge_date)}</td>
                                    <td>{d.ddt_number}</td>
                                    <td>{d.employee_name} {d.employee_surname}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default ProductDetailPage;
